// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let React = require("react");
let Scalars = require("../../scalars/Scalars.bs.js");
let Tooltip = require("../../reason/common/Tooltip.bs.js");
let ButtonsV5 = require("../../uikit/reason/atoms/Buttons/ButtonsV5.bs.js");
let Formality = require("../../vendor/re-formality/Formality.bs.js");
let IconButton = require("../../reason/common/IconButton.bs.js");
let AvatarSrcUrl = require("../../utils/AvatarSrcUrl.bs.js");
let Avatar__Jsx3 = require("../../uikit/reason/atoms/Avatar/Avatar__Jsx3.bs.js");
let ConfirmDialog = require("../../reason/common/ConfirmDialog/ConfirmDialog.bs.js");
let Form__Helpers = require("../../reason/common/Form/Form__Helpers.bs.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let SystemMessages = require("../../reason/systemMessages/SystemMessages.bs.js");
let Form__Components = require("../../reason/common/Form/Form__Components.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let AccountMemberUtils = require("./AccountMemberUtils.bs.js");
let Formality__ReactUpdate = require("../../vendor/re-formality/Formality__ReactUpdate.bs.js");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let RescriptRelay_Mutation = require("rescript-relay/src/RescriptRelay_Mutation.bs.js");
let SubusersPageAccountsList_account_graphql = require("../../__generated__/SubusersPageAccountsList_account_graphql.bs.js");
let SubusersPageAccountsListItem_member_graphql = require("../../__generated__/SubusersPageAccountsListItem_member_graphql.bs.js");
let SubusersPageAccountsListItem_account_graphql = require("../../__generated__/SubusersPageAccountsListItem_account_graphql.bs.js");
let SubusersPageAccountsListItem_RemoveMemberV5Mutation_graphql = require("../../__generated__/SubusersPageAccountsListItem_RemoveMemberV5Mutation_graphql.bs.js");
let SubusersPageAccountsListItem_UpdateMemberV5Mutation_graphql = require("../../__generated__/SubusersPageAccountsListItem_UpdateMemberV5Mutation_graphql.bs.js");

function SubusersPageAccountsListItem$ConfirmRemoveDialog(props) {
  let name = props.name;
  let onCancel = props.onCancel;
  let onConfirm = props.onConfirm;
  return JsxRuntime.jsx(JsxRuntime.Fragment, {
    children: JsxRuntime.jsx(ConfirmDialog.make, {
      title: `Remove ` + name + `?`,
      ariaLabel: `Confirm removal of ` + name,
      body: JsxRuntime.jsxs(JsxRuntime.Fragment, {
        children: [
          JsxRuntime.jsx("div", {
            children: name + " will be permanently removed from your account. You will assume ownership of all their clients and messages.",
            className: "leading-normal"
          }),
          JsxRuntime.jsx("br", {}),
          JsxRuntime.jsx("span", {
            children: "Once confirmed, the removal is not reversible.",
            className: "font-bold"
          })
        ]
      }),
      isOpen: props.isOpen,
      onCancel: onCancel,
      cancelButton: JsxRuntime.jsx(ButtonsV5.SecondaryButton.make, {
        onClick: param => onCancel(),
        children: "Cancel"
      }),
      confirmButton: JsxRuntime.jsx(ButtonsV5.DangerButton.make, {
        onClick: param => onConfirm(),
        children: "Yes, remove them"
      })
    })
  });
}

let ConfirmRemoveDialog = {
  View: undefined,
  Buttons: undefined,
  make: SubusersPageAccountsListItem$ConfirmRemoveDialog
};

let validators = {
  role: {
    strategy: "OnFirstSuccessOrFirstBlur",
    validate: param => {
      let role = param.role;
      if (role !== undefined) {
        return {
          TAG: "Ok",
          _0: role
        };
      } else {
        return {
          TAG: "Error",
          _0: "is required"
        };
      }
    }
  }
};

function initialFieldsStatuses(input) {
  return {
    role: "Pristine"
  };
}

function initialFieldStatuses_xxx(x) {
  return {
    role: "Pristine"
  };
}

function initialState(input) {
  return {
    input: input,
    fieldsStatuses: {
      role: "Pristine"
    },
    collectionsStatuses: undefined,
    formStatus: "Editing",
    submissionStatus: "NeverSubmitted"
  };
}

function validateForm(input, validators, fieldsStatuses) {
  let match = fieldsStatuses.role;
  let match$1;
  match$1 = typeof match !== "object" ? validators.role.validate(input) : match._0;
  if (match$1.TAG === "Ok") {
    return {
      TAG: "Valid",
      output: {
        role: match$1._0
      },
      fieldsStatuses: {
        role: {
          TAG: "Dirty",
          _0: match$1,
          _1: "Shown"
        }
      },
      collectionsStatuses: undefined
    };
  } else {
    return {
      TAG: "Invalid",
      fieldsStatuses: {
        role: {
          TAG: "Dirty",
          _0: match$1,
          _1: "Shown"
        }
      },
      collectionsStatuses: undefined
    };
  }
}

function useForm(initialInput, onSubmit) {
  let memoizedInitialState = React.useMemo(() => initialState(initialInput), [initialInput]);
  let match = Formality__ReactUpdate.useReducer(memoizedInitialState, (state, action) => {
    if (typeof action !== "object") {
      switch (action) {
        case "BlurRoleField" :
          let result = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.role, validators.role, status => ({
            role: status
          }));
          if (result !== undefined) {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: result,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: state.formStatus,
                submissionStatus: state.submissionStatus
              }
            };
          } else {
            return "NoUpdate";
          }
        case "Submit" :
          let match = state.formStatus;
          if (typeof match === "object" && match.TAG === "Submitting") {
            return "NoUpdate";
          }
          let match$1 = validateForm(state.input, validators, state.fieldsStatuses);
          if (match$1.TAG !== "Valid") {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: match$1.fieldsStatuses,
                collectionsStatuses: match$1.collectionsStatuses,
                formStatus: "Editing",
                submissionStatus: "AttemptedToSubmit"
              }
            };
          }
          let output = match$1.output;
          let error = state.formStatus;
          let tmp;
          tmp = typeof error !== "object" || error.TAG !== "SubmissionFailed" ? undefined : error._0;
          return {
            TAG: "UpdateWithSideEffects",
            _0: {
              input: state.input,
              fieldsStatuses: match$1.fieldsStatuses,
              collectionsStatuses: match$1.collectionsStatuses,
              formStatus: {
                TAG: "Submitting",
                _0: tmp
              },
              submissionStatus: "AttemptedToSubmit"
            },
            _1: param => {
              let dispatch = param.dispatch;
              onSubmit(output, {
                notifyOnSuccess: input => dispatch({
                  TAG: "SetSubmittedStatus",
                  _0: input
                }),
                notifyOnFailure: error => dispatch({
                  TAG: "SetSubmissionFailedStatus",
                  _0: error
                }),
                reset: () => dispatch("Reset"),
                dismissSubmissionResult: () => dispatch("DismissSubmissionResult")
              });
            }
          };
          break;
        case "DismissSubmissionError" :
          let match$2 = state.formStatus;
          if (typeof match$2 !== "object" || match$2.TAG !== "SubmissionFailed") {
            return "NoUpdate";
          } else {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: state.fieldsStatuses,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: "Editing",
                submissionStatus: state.submissionStatus
              }
            };
          }
        case "DismissSubmissionResult" :
          let match$3 = state.formStatus;
          if (typeof match$3 !== "object") {
            if (match$3 === "Editing") {
              return "NoUpdate";
            }
          } else if (match$3.TAG === "Submitting") {
            return "NoUpdate";
          }
          return {
            TAG: "Update",
            _0: {
              input: state.input,
              fieldsStatuses: state.fieldsStatuses,
              collectionsStatuses: state.collectionsStatuses,
              formStatus: "Editing",
              submissionStatus: state.submissionStatus
            }
          };
        case "Reset" :
          return {
            TAG: "Update",
            _0: initialState(initialInput)
          };
      }
    } else {
      switch (action.TAG) {
        case "UpdateRoleField" :
          let nextInput = action._0(state.input);
          return {
            TAG: "Update",
            _0: {
              input: nextInput,
              fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput, state.fieldsStatuses.role, state.submissionStatus, validators.role, status => ({
                role: status
              })),
              collectionsStatuses: state.collectionsStatuses,
              formStatus: state.formStatus,
              submissionStatus: state.submissionStatus
            }
          };
        case "SetSubmittedStatus" :
          let input = action._0;
          if (input !== undefined) {
            return {
              TAG: "Update",
              _0: {
                input: input,
                fieldsStatuses: {
                  role: "Pristine"
                },
                collectionsStatuses: state.collectionsStatuses,
                formStatus: "Submitted",
                submissionStatus: state.submissionStatus
              }
            };
          } else {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: {
                  role: "Pristine"
                },
                collectionsStatuses: state.collectionsStatuses,
                formStatus: "Submitted",
                submissionStatus: state.submissionStatus
              }
            };
          }
        case "SetSubmissionFailedStatus" :
          return {
            TAG: "Update",
            _0: {
              input: state.input,
              fieldsStatuses: state.fieldsStatuses,
              collectionsStatuses: state.collectionsStatuses,
              formStatus: {
                TAG: "SubmissionFailed",
                _0: action._0
              },
              submissionStatus: state.submissionStatus
            }
          };
        case "MapSubmissionError" :
          let map = action._0;
          let error$1 = state.formStatus;
          if (typeof error$1 !== "object") {
            return "NoUpdate";
          }
          if (error$1.TAG !== "Submitting") {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: state.fieldsStatuses,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: {
                  TAG: "SubmissionFailed",
                  _0: map(error$1._0)
                },
                submissionStatus: state.submissionStatus
              }
            };
          }
          let error$2 = error$1._0;
          if (error$2 !== undefined) {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: state.fieldsStatuses,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: {
                  TAG: "Submitting",
                  _0: map(error$2)
                },
                submissionStatus: state.submissionStatus
              }
            };
          } else {
            return "NoUpdate";
          }
      }
    }
  });
  let dispatch = match[1];
  let state = match[0];
  let match$1 = state.formStatus;
  let tmp;
  tmp = typeof match$1 !== "object" ? false : match$1.TAG === "Submitting";
  return {
    updateRole: (nextInputFn, nextValue) => dispatch({
      TAG: "UpdateRoleField",
      _0: __x => nextInputFn(__x, nextValue)
    }),
    blurRole: () => dispatch("BlurRoleField"),
    roleResult: Formality.exposeFieldResult(state.fieldsStatuses.role),
    input: state.input,
    status: state.formStatus,
    dirty: () => {
      let match = state.fieldsStatuses;
      let tmp = match.role;
      return typeof tmp === "object";
    },
    valid: () => {
      let match = validateForm(state.input, validators, state.fieldsStatuses);
      return match.TAG === "Valid";
    },
    submitting: tmp,
    submit: () => dispatch("Submit"),
    dismissSubmissionError: () => dispatch("DismissSubmissionError"),
    dismissSubmissionResult: () => dispatch("DismissSubmissionResult"),
    mapSubmissionError: map => dispatch({
      TAG: "MapSubmissionError",
      _0: map
    }),
    reset: () => dispatch("Reset")
  };
}

let FormConfig = {
  validators: validators,
  initialFieldsStatuses: initialFieldsStatuses,
  initialFieldStatuses_xxx: initialFieldStatuses_xxx,
  initialCollectionsStatuses: undefined,
  initialState: initialState,
  validateForm: validateForm,
  useForm: useForm
};

let convertFragment = SubusersPageAccountsListItem_account_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, SubusersPageAccountsListItem_account_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(SubusersPageAccountsListItem_account_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, SubusersPageAccountsListItem_account_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(SubusersPageAccountsListItem_account_graphql.node, convertFragment, fRef);
}

let AccountFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

let accountMemberRole_decode = SubusersPageAccountsListItem_member_graphql.Utils.accountMemberRole_decode;

let convertFragment$1 = SubusersPageAccountsListItem_member_graphql.Internal.convertFragment;

function waitForFragmentData$1(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, SubusersPageAccountsListItem_member_graphql.node, convertFragment$1, fRef);
}

function use$1(fRef) {
  return RescriptRelay_Fragment.useFragment(SubusersPageAccountsListItem_member_graphql.node, convertFragment$1, fRef);
}

function useOpt$1(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, SubusersPageAccountsListItem_member_graphql.node, convertFragment$1);
}

function readResolverFragment$1(fRef) {
  return RescriptRelay_Fragment.read(SubusersPageAccountsListItem_member_graphql.node, convertFragment$1, fRef);
}

let MemberFragment_accountMemberRole_fromString = SubusersPageAccountsListItem_member_graphql.Utils.accountMemberRole_fromString;

let MemberFragment = {
  accountMemberRole_decode: accountMemberRole_decode,
  accountMemberRole_fromString: MemberFragment_accountMemberRole_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$1,
  waitForFragmentData: waitForFragmentData$1,
  use: use$1,
  useOpt: useOpt$1,
  readResolverFragment: readResolverFragment$1
};

let convertVariables = SubusersPageAccountsListItem_UpdateMemberV5Mutation_graphql.Internal.convertVariables;

let convertResponse = SubusersPageAccountsListItem_UpdateMemberV5Mutation_graphql.Internal.convertResponse;

let convertWrapRawResponse = SubusersPageAccountsListItem_UpdateMemberV5Mutation_graphql.Internal.convertWrapRawResponse;

let commitMutation = RescriptRelay_Mutation.commitMutation(convertVariables, SubusersPageAccountsListItem_UpdateMemberV5Mutation_graphql.node, convertResponse, convertWrapRawResponse);

let use$2 = RescriptRelay_Mutation.useMutation(convertVariables, SubusersPageAccountsListItem_UpdateMemberV5Mutation_graphql.node, convertResponse, convertWrapRawResponse);

let UpdateMemberV5Mutation_accountMemberRoleInput_decode = SubusersPageAccountsListItem_UpdateMemberV5Mutation_graphql.Utils.accountMemberRoleInput_decode;

let UpdateMemberV5Mutation_accountMemberRoleInput_fromString = SubusersPageAccountsListItem_UpdateMemberV5Mutation_graphql.Utils.accountMemberRoleInput_fromString;

let UpdateMemberV5Mutation = {
  accountMemberRoleInput_decode: UpdateMemberV5Mutation_accountMemberRoleInput_decode,
  accountMemberRoleInput_fromString: UpdateMemberV5Mutation_accountMemberRoleInput_fromString,
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  commitMutation: commitMutation,
  use: use$2
};

let convertVariables$1 = SubusersPageAccountsListItem_RemoveMemberV5Mutation_graphql.Internal.convertVariables;

let convertResponse$1 = SubusersPageAccountsListItem_RemoveMemberV5Mutation_graphql.Internal.convertResponse;

let convertWrapRawResponse$1 = SubusersPageAccountsListItem_RemoveMemberV5Mutation_graphql.Internal.convertWrapRawResponse;

let commitMutation$1 = RescriptRelay_Mutation.commitMutation(convertVariables$1, SubusersPageAccountsListItem_RemoveMemberV5Mutation_graphql.node, convertResponse$1, convertWrapRawResponse$1);

let use$3 = RescriptRelay_Mutation.useMutation(convertVariables$1, SubusersPageAccountsListItem_RemoveMemberV5Mutation_graphql.node, convertResponse$1, convertWrapRawResponse$1);

let RemoveMemberV5Mutation = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables$1,
  convertResponse: convertResponse$1,
  convertWrapRawResponse: convertWrapRawResponse$1,
  commitMutation: commitMutation$1,
  use: use$3
};

function SubusersPageAccountsListItem(props) {
  let currentUserRole = props.currentUserRole;
  let match = use$2();
  let updateMember = match[0];
  let match$1 = use$3();
  let removeMember = match$1[0];
  let member = RescriptRelay_Fragment.useFragment(SubusersPageAccountsListItem_member_graphql.node, convertFragment$1, props.member);
  let account = RescriptRelay_Fragment.useFragment(SubusersPageAccountsListItem_account_graphql.node, convertFragment, props.account);
  let match$2 = React.useState(() => false);
  let setIsEditing = match$2[1];
  let form = useForm({
    role: Stdlib_Option.flatMap(Stdlib_Option.flatMap(member.role, v => accountMemberRole_decode(v)), role => {
      switch (role) {
        case "ASSISTANT" :
          return "ASSISTANT";
        case "ASSOCIATE" :
          return "ASSOCIATE";
        case "BUYER_SPECIALIST" :
          return "BUYER_SPECIALIST";
        case "CLIENT_CARE_COORDINATOR" :
          return "CLIENT_CARE_COORDINATOR";
        case "INSIDE_SALES_AGENT" :
          return "INSIDE_SALES_AGENT";
        case "LISTING_MANAGER" :
          return "LISTING_MANAGER";
        case "LISTING_SPECIALIST" :
          return "LISTING_SPECIALIST";
        case "MARKETING_SPECIALIST" :
          return "MARKETING_SPECIALIST";
        case "OPERATIONS_MANAGER" :
          return "OPERATIONS_MANAGER";
        case "PARTNER" :
          return "PARTNER";
        case "SHOWING_ASSISTANT" :
          return "SHOWING_ASSISTANT";
        case "TRANSACTION_COORDINATOR" :
          return "TRANSACTION_COORDINATOR";
        case "OWNER" :
        case "UNKNOWN" :
          return;
      }
    })
  }, (param, param$1) => {
    let notifyOnFailure = param$1.notifyOnFailure;
    let notifyOnSuccess = param$1.notifyOnSuccess;
    updateMember({
      input: {
        id: member.id,
        role: param.role
      }
    }, undefined, undefined, undefined, (param, param$1) => {
      let updateMemberV5 = param.updateMemberV5;
      if (updateMemberV5 !== undefined && updateMemberV5.__typename === "AccountMemberUpdated") {
        return notifyOnSuccess(undefined);
      } else {
        return notifyOnFailure("Error updating data. Please refresh and try again...");
      }
    }, undefined, undefined);
  });
  let match$3 = member.agent;
  let firstName = match$3.firstName;
  let name;
  if (firstName !== undefined) {
    let lastName = match$3.lastName;
    name = lastName !== undefined ? firstName + " " + lastName : firstName;
  } else {
    let lastName$1 = match$3.lastName;
    name = lastName$1 !== undefined ? lastName$1 : match$3.displayName;
  }
  let match$4 = member.role;
  let memberCanBeEdited = match$4 !== undefined && (match$4 === "ASSISTANT" || match$4 === "UNKNOWN" || match$4 === "ASSOCIATE" || match$4 === "TRANSACTION_COORDINATOR" || match$4 === "BUYER_SPECIALIST" || match$4 === "SHOWING_ASSISTANT" || match$4 === "CLIENT_CARE_COORDINATOR" || match$4 === "PARTNER" || match$4 === "INSIDE_SALES_AGENT" || match$4 === "OWNER" || match$4 === "LISTING_MANAGER" || match$4 === "OPERATIONS_MANAGER" || match$4 === "LISTING_SPECIALIST" || match$4 === "MARKETING_SPECIALIST") ? match$4 !== "OWNER" : true;
  let canEdit = currentUserRole === "OWNER";
  let match$5 = SystemMessages.useSystemMessages();
  let addMessage = match$5.addMessage;
  let addErrorMessage = () => addMessage(SystemMessages.Message.make(undefined, "error", "There was a problem removing the member. Please try again or contact us.", 5000, undefined, undefined));
  let addSuccessMessage = () => addMessage(SystemMessages.Message.make(undefined, "info", "The member was removed successfully", 5000, undefined, undefined));
  let removeMember$1 = () => {
    removeMember({
      connections: [SubusersPageAccountsList_account_graphql.makeConnectionId(account.__id)],
      input: {
        id: member.id
      }
    }, undefined, undefined, undefined, (response, param) => {
      let match = response.removeMemberV5;
      if (match !== undefined && match.__typename === "AccountMemberRemoved") {
        return addSuccessMessage();
      } else {
        return addErrorMessage();
      }
    }, undefined, undefined);
  };
  let match$6 = React.useState(() => false);
  let setConfirmRemoveDialogOpen = match$6[1];
  let match$7 = member.agent.profilePhoto;
  let tmp;
  if (match$2[0]) {
    let match$8 = form.roleResult;
    let tmp$1;
    tmp$1 = match$8 !== undefined ? (
        match$8.TAG === "Ok" ? "Ok" : "Error"
      ) : undefined;
    tmp = JsxRuntime.jsxs("div", {
      children: [
        JsxRuntime.jsx(Form__Components.FormStatusMessageV2.make, {
          status: form.status,
          submissionErrorToString: v => v,
          onSuccessMessage: "Account updated",
          resetForm: () => {
            form.reset();
            setIsEditing(param => false);
          },
          dismissSubmissionResult: form.dismissSubmissionResult
        }),
        JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsx("div", {
              children: JsxRuntime.jsx("div", {
                children: "First name:",
                className: "font-semibold"
              }),
              className: "col-span-1"
            }),
            JsxRuntime.jsx("div", {
              children: Stdlib_Option.getOr(member.agent.firstName, ""),
              className: "col-span-3"
            })
          ],
          className: "grid grid-cols-4 gap-4"
        }),
        JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsx("div", {
              children: JsxRuntime.jsx("div", {
                children: "Last name:",
                className: "font-semibold"
              }),
              className: "col-span-1"
            }),
            JsxRuntime.jsx("div", {
              children: Stdlib_Option.getOr(member.agent.lastName, ""),
              className: "col-span-3"
            })
          ],
          className: "grid grid-cols-4 gap-4"
        }),
        JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsx("div", {
              children: JsxRuntime.jsx("div", {
                children: "Email:",
                className: "font-semibold"
              }),
              className: "col-span-1"
            }),
            JsxRuntime.jsx("div", {
              children: Stdlib_Option.getOr(Stdlib_Option.map(member.agent.emailAddress, v => Scalars.EmailAddress.toString(v)), ""),
              className: "col-span-3"
            })
          ],
          className: "grid grid-cols-4 gap-4"
        }),
        JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsx("div", {
              children: JsxRuntime.jsx("div", {
                children: "Display name:",
                className: "font-semibold"
              }),
              className: "col-span-1"
            }),
            JsxRuntime.jsx("div", {
              children: member.agent.displayName,
              className: "col-span-3"
            })
          ],
          className: "grid grid-cols-4 gap-4"
        }),
        JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsx("div", {
              children: JsxRuntime.jsx("div", {
                children: "Role:",
                className: "font-semibold"
              }),
              className: "col-span-1"
            }),
            JsxRuntime.jsx("div", {
              children: JsxRuntime.jsx("div", {
                children: JsxRuntime.jsx(AccountMemberUtils.RoleSelectComponent.make, {
                  onChange: value => form.updateRole((param, value) => ({
                    role: value
                  }), value !== undefined ? value.value : undefined),
                  result: tmp$1,
                  value: Stdlib_Option.map(form.input.role, v => AccountMemberUtils.SelectOpts.make(v))
                })
              }),
              className: "col-span-3"
            })
          ],
          className: "grid grid-cols-4 gap-4"
        }),
        JsxRuntime.jsx("div", {
          children: JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx(ButtonsV5.PrimaryButton.make, {
                onClick: extra => Form__Helpers.preventDefault(form.submit, extra),
                disabled: match[1] || form.submitting,
                children: "Save"
              }),
              JsxRuntime.jsx(ButtonsV5.SecondaryButton.make, {
                onClick: param => setIsEditing(param => false),
                children: "Cancel"
              })
            ],
            className: "flex flex-row space-x-2"
          }),
          className: "grid grid-cols-4 gap-4"
        })
      ],
      className: "flex flex-col space-y-4 w-full"
    });
  } else {
    tmp = JsxRuntime.jsxs("div", {
      children: [
        JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("div", {
                  children: name,
                  className: "font-semibold"
                }),
                JsxRuntime.jsx("div", {
                  children: name === member.agent.displayName ? null : JsxRuntime.jsx("div", {
                      children: member.agent.displayName
                    }),
                  className: "text-gray-500"
                })
              ]
            }),
            JsxRuntime.jsx("div", {
              children: JsxRuntime.jsx("div", {
                children: JsxRuntime.jsxs("div", {
                  children: [
                    JsxRuntime.jsx("div", {
                      children: Stdlib_Option.getOr(Stdlib_Option.map(member.agent.emailAddress, e => Scalars.EmailAddress.toString(e)), null),
                      className: ""
                    }),
                    JsxRuntime.jsx("div", {
                      children: Stdlib_Option.getOr(Stdlib_Option.map(Stdlib_Option.flatMap(member.role, r => accountMemberRole_decode(r)), AccountMemberUtils.roleToString), null),
                      className: "text-gray-500"
                    })
                  ],
                  className: ""
                }),
                className: "col-span-3 flex justify-between"
              })
            })
          ],
          className: "flex flex-row space-x-4"
        }),
        JsxRuntime.jsx("div", {
          children: memberCanBeEdited ? JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx(Tooltip.make, {
                  label: canEdit ? "Edit the member's role" : "Only the account owner can edit member roles",
                  children: JsxRuntime.jsx("span", {
                    children: JsxRuntime.jsx(IconButton.make, {
                      icon: "pencil",
                      onPress: () => setIsEditing(param => true),
                      title: "Edit user",
                      disabled: !canEdit
                    })
                  })
                }),
                JsxRuntime.jsx(Tooltip.make, {
                  label: canEdit ? "Remove the member from your account" : "Only the account owner can remove members",
                  children: JsxRuntime.jsx("span", {
                    children: JsxRuntime.jsx(IconButton.make, {
                      icon: "trash",
                      onPress: () => setConfirmRemoveDialogOpen(param => true),
                      title: "Remove user",
                      disabled: !canEdit || match$1[1]
                    })
                  })
                })
              ],
              className: "flex flex-row space-x-1"
            }) : null
        })
      ],
      className: "flex flex-row space-x-4 justify-between w-full"
    });
  }
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx(SubusersPageAccountsListItem$ConfirmRemoveDialog, {
        isOpen: match$6[0],
        onConfirm: () => {
          removeMember$1();
          setConfirmRemoveDialogOpen(param => false);
        },
        onCancel: () => setConfirmRemoveDialogOpen(param => false),
        name: name
      }),
      JsxRuntime.jsx("div", {
        children: JsxRuntime.jsx(Avatar__Jsx3.make, {
          src: match$7 !== undefined ? match$7.url : AvatarSrcUrl.place_holder,
          name: name,
          size: "tiny"
        })
      }),
      tmp
    ],
    className: "flex flex-row space-x-4 my-4 items-start"
  });
}

let make = SubusersPageAccountsListItem;

exports.ConfirmRemoveDialog = ConfirmRemoveDialog;
exports.FormConfig = FormConfig;
exports.AccountFragment = AccountFragment;
exports.MemberFragment = MemberFragment;
exports.UpdateMemberV5Mutation = UpdateMemberV5Mutation;
exports.RemoveMemberV5Mutation = RemoveMemberV5Mutation;
exports.make = make;
/* commitMutation Not a pure module */
